import React from 'react';
import parse from 'html-react-parser';
import { InlineExternalLink } from '@monash/portal-react';

// takes in a string and replaces all <a> elements with an ExternalLink component
export const swapAnchorForExternalLink = (string) => {
  return parse(string, {
    replace: ({ attribs, name, children }) => {
      if (name === 'a') {
        const text = children[0]?.data;
        return <InlineExternalLink text={text} link={attribs.href} />;
      }
    },
  });
};
